import { useSelector } from 'react-redux';
import SearchThreadListHeader from '../../thread-search-and-filtering/components/SearchThreadListHeader';
import RealtimeThreadListHeader from './RealtimeThreadListHeader';
import { isInSearchAndFilterMode as getIsInSearchAndFilterMode } from 'conversations-inbox-lib/thread-search-and-filtering/public/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOptionsBarContainer = () => {
  const isInSearchAndFilteringMode = useSelector(getIsInSearchAndFilterMode);
  if (isInSearchAndFilteringMode) {
    return /*#__PURE__*/_jsx(SearchThreadListHeader, {});
  } else {
    return /*#__PURE__*/_jsx(RealtimeThreadListHeader, {});
  }
};
FilterOptionsBarContainer.displayName = 'FilterOptionsBarContainer';
export default FilterOptionsBarContainer;